export const WARNING_MESSAGES = {
  sessionNotStarted:
    'You are trying to enter the session that has not started yet. Please wait until the session starts.',
  classCodeDoesNotExists: 'You are trying to use a non-existing class code. Please enter the class code manually.',
  invalidName: 'Name is invalid. Please enter a valid name.',
  invalidClassCode: 'Class code is invalid. Please enter a valid class code.',
  duplicateStudentName: 'A student with the same name has already joined the session. Please use a different name.',
};
